// removed by extract-text-webpack-plugin
module.exports = {"root":"LayoutWrapperSideNav__root__lVHCq","tabs":"LayoutWrapperSideNav__tabs__EKdgG","tab":"LayoutWrapperSideNav__tab__1-6Ra"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LayoutWrapperSideNav/LayoutWrapperSideNav.css
// module id = 1872
// module chunks = 0